<template>
  <div class="project-wrapper">
    <div class="project-container">
      <div class="project-content">
        <p class="project-current-step">{{ Translator('soprasolar.project.step2.step') }}</p>
        <h1 class="project-title">{{ Translator('soprasolar.project.step2.title') }}</h1>
        <save />
      </div>
      <div class="project-content">
        <form @submit="onSubmit" ref="form" id="form" class="std-form">
          <div class="form-group">
            <div class="form-label-container">
              <label for="projectName" class="control-label required">
                {{ Translator('soprasolar.project.step2.form.project_name') }}
              </label>
            </div>
            <input type="text" id="projectName" class="form-control" v-model="form.projectName" required>
          </div>
          <div class="form-group">
            <div class="form-label-container">
              <label for="address" class="control-label required">
                {{ Translator('soprasolar.project.step2.form.address') }}
              </label>
            </div>
            <input type="text" id="address" class="form-control" v-model="form.address" required>
          </div>
          <div class="form-row">
            <div class="form-group">
              <div class="form-label-container">
                <label for="zipCode" class="control-label required">
                  {{ Translator('soprasolar.project.step2.form.zip_code') }}
                </label>
              </div>
              <input type="text" id="zipCode" class="form-control" v-model="form.zipCode" required>
            </div>
            <div class="form-group">
              <div class="form-label-container">
                <label for="city" class="control-label required">
                  {{ Translator('soprasolar.project.step2.form.city') }}
                </label>
              </div>
              <input type="text" id="city" class="form-control" v-model="form.city" required>
            </div>
            <div class="form-group">
              <div class="form-label-container">
                <label for="city" class="control-label required">
                  {{ Translator('soprasolar.project.step2.form.country') }}
                </label>
              </div>
              <select class="form-control" v-model="form.country" id="country" required>
                <option v-for="country in countries" :key="country.code" :value="country.code">{{ country.name }}</option>
              </select>
            </div>
          </div>

          <div class="form-group" v-if="datas && datas.step0 && datas.step0.type === 'terrace'">
            <div class="form-label-container">
              <label for="classification" class="control-label required">
                {{ Translator('soprasolar.project.step2.form.classification.label') }}
              </label>
            </div>
            <div class="radios">
              <div class="radio">
                <input class="radio-input" type="radio" id="classification_home" name="classification" v-model="form.classification" value="home" required>
                <label class="radio-label" for="classification_home">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step2.form.classification.home') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" type="radio" id="classification_erp" name="classification" v-model="form.classification" value="erp" required>
                <label class="radio-label" for="classification_erp">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step2.form.classification.erp') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" type="radio" id="classification_labor" name="classification" v-model="form.classification" value="labor" required>
                <label class="radio-label" for="classification_labor">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step2.form.classification.labor') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" type="radio" id="classification_icpe" name="classification" v-model="form.classification" value="icpe" required>
                <label class="radio-label" for="classification_icpe">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step2.form.classification.icpe') }}</p>
                </label>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="elevation" class="control-label">
                {{ Translator('soprasolar.project.step2.form.elevation') }}
              </label>
            </div>
            <input type="text" id="elevation" class="form-control" v-model="form.elevation">
          </div>
          <div class="form-group" v-if="datas && datas.step0 && datas.step0.type === 'shade'">
            <div class="form-label-container">
              <label for="category" class="control-label required">
                {{ Translator('soprasolar.project.step2.form.category.label') }}
              </label>
              <help :image="'/assets/soprasolar/images/project/help-shade-categories.png'" />
            </div>
            <select id="category" required class="form-control" v-model="form.category">
              <option value=""></option>
              <option value="0">{{ Translator('soprasolar.project.step2.form.category.0') }}</option>
              <option value="II">{{ Translator('soprasolar.project.step2.form.category.II') }}</option>
              <option value="IIIa">{{ Translator('soprasolar.project.step2.form.category.IIIa') }}</option>
              <option value="IIIb">{{ Translator('soprasolar.project.step2.form.category.IIIb') }}</option>
              <option value="IV">{{ Translator('soprasolar.project.step2.form.category.IV') }}</option>
            </select>
          </div>

          <div class="form-group">
            <div class="form-label-container">
              <label for="coefficient" class="control-label required">
                {{ Translator('soprasolar.project.step2.form.coefficient.label') }}
              </label>
            </div>

            <div class="radios">
              <div class="radio">
                <input class="radio-input" type="radio" id="coefficient_normal" name="coefficient" v-model="form.coefficient" value="normal" required>
                <label class="radio-label" for="coefficient_normal">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step2.form.coefficient.normal') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" type="radio" id="coefficient_exposed" name="coefficient" v-model="form.coefficient" value="exposed" required>
                <label class="radio-label" for="coefficient_exposed">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step2.form.coefficient.exposed') }}</p>
                </label>
              </div>
              <div class="radio">
                <input class="radio-input" type="radio" id="coefficient_dontknow" name="coefficient" v-model="form.coefficient" value="dontknow" required>
                <label class="radio-label" for="coefficient_dontknow">
                  <p class="radio-label-text">{{ Translator('soprasolar.project.step2.form.coefficient.dontknow') }}</p>
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="project-footer">
      <div class="project-actions">
        <button type="submit" class="button-flat" form="form" :disabled="isLoading">
          {{ Translator('soprasolar.project.next') }}
          <i class="ic ic-arrow-right" v-if="!isLoading"></i>
          <span class="button-loader" v-if="isLoading"></span>
        </button>
        <button type="button" class="button-link" @click="onPrevious">
          <i class="ic ic-arrow-left"></i>
          {{ Translator('soprasolar.project.previous') }}
        </button>
      </div>
    </div>
    <p class="project-legend">* {{ Translator('soprasolar.project.required_field') }}</p>
  </div>
</template>
<style scoped lang="scss">
@import "~@/soprasolar-project/assets/styles/import";
.project-wrapper {
  @include vertical-spacing-inner-top;
}
</style>
<script>
import FormControl from 'aw-front-helpers/classes/formControl';
import countryList from 'country-list-js';
import AppControlService from '@/soprasolar-project/services/AppControl';
import Save from '@/soprasolar-project/components/Save';
import Help from '@/soprasolar-project/components/Help';

export default {
  name: 'step-2',
  components: {
    Save,
    Help
  },
  data () {
    return {
      countries: [],
      datas: AppControlService.datas,
      isLoading: false,
      form: {
        country: 'FR'
      }
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
    const countries = [];
    const forbiddenCountries = ["Guadeloupe", "Martinique", "French Guiana", "Reunion", "Mayotte"];

    for (let code in countryList.all) {
      const countryName = countryList.all[code].name;
      const countryCode = countryList.all[code].iso2;
      if (!forbiddenCountries.includes(countryName)) {
        countries.push({
          code: countryCode,
          name: countryName
        });
      }
    }

    countries.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
    this.countries = countries;
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {
    this._form = new FormControl(this.$refs.form);
    if(this.datas.step2) this.form = this.datas.step2;
  },

  methods: {
    onSubmit(pEvt) {
      pEvt.preventDefault();
      if(this._form.isValidate) {
        if(this.isLoading) return;
        this.isLoading = true;
        AppControlService.update('step2', this.form).then( () => {
          AppControlService.goToNextStep();
        }).catch(console.error).then(() => {
          this.isLoading = false;
        })
      }
    },

    onPrevious() {
      AppControlService.goToPrevStep();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
      if(this.datas.step2) this.form = this.datas.step2;
    }
  }
};
</script>